// extracted by mini-css-extract-plugin
export default {"dark":"AccountOwner_dark__xpgaX","App":"AccountOwner_App__YDZc-","containerAccountOwner":"AccountOwner_containerAccountOwner__FISCz"};